import { RESET_DEPOSITS } from './const/deposits';
import { RESET_SETTINGS } from './const/settings';
import { AUTH_LOGOUT } from './const/user';
import { RESET_WALLETS } from './const/wallets';
import { RESET_WITHDRAWS } from './const/withdraws';

export const resetSessionState = (commit) => {
  commit(`deposits/${RESET_DEPOSITS}`, null, { root: true });
  commit(`withdraws/${RESET_WITHDRAWS}`, null, { root: true });
  commit(`wallets/${RESET_WALLETS}`, null, { root: true });
  commit(`settings/${RESET_SETTINGS}`, null, { root: true });
  commit(`user/${AUTH_LOGOUT}`, null, { root: true });
};
